/* The first 50 source products are filtered in Liquid. Follow every remaining
   page so the carousel includes all matching compositions, without duplicates. */
if (!customElements.get('related-compositions')) {
  customElements.define('related-compositions', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.more !== 'true' || this.loading) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.loadMore();
        }
      }, { rootMargin: '400px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async loadMore() {
      if (this.loading) return;
      this.loading = true;
      this.controller = new AbortController();
      const track = this.querySelector('.ear-compositions__track');
      const ids = new Set([...track.children].map(card => card.dataset.productId));
      const status = this.querySelector('[data-composition-status]');
      let page = 2;
      try {
        while (page) {
          const url = new URL(this.dataset.source, location.origin);
          url.searchParams.set('view', this.dataset.color === 'silver' ? 'related-compositions-silver-feed' : 'related-compositions-feed');
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Composition feed unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = doc.querySelector('[data-related-composition-feed]');
          if (!feed) throw new Error('Composition feed missing');
          for (const card of feed.children) {
            const values = this.dataset.matchBy === 'placement' ? card.dataset.placements : card.dataset.collections;
            const value = this.dataset.matchBy === 'placement' ? this.dataset.placement : this.dataset.collection;
            if (!values?.includes(`|${value}|`) || ids.has(card.dataset.productId)) continue;
            ids.add(card.dataset.productId);
            // Give imported cards the same unique section scope as server cards.
            card.innerHTML = card.innerHTML.replaceAll('RelatedCompositionFeed', this.dataset.section);
            card.id = `Slide-${this.dataset.section}-${card.dataset.productId}`;
            track.append(document.importNode(card, true));
          }
          this.refresh(ids.size);
          const next = Number(feed.dataset.nextPage) || 0;
          if (next && next <= page) throw new Error('Invalid composition pagination');
          page = next;
        }
        this.dataset.more = 'false';
        status.hidden = true;
        if (!ids.size && !window.Shopify?.designMode) this.hidden = true;
      } catch (error) {
        if (error.name !== 'AbortError') {
          status.textContent = document.documentElement.lang.split('-')[0] === 'en' ? 'More ear stacks could not be loaded. Use the link below to browse them.' : 'La suite des compositions n’a pas pu être chargée. Retrouvez-les avec le lien ci-dessous.';
          status.hidden = false;
        }
      } finally {
        this.loading = false;
      }
    }
    refresh(count) {
      const slider = this.querySelector('slider-component');
      slider.classList.toggle('ear-compositions__slider--fits-desktop', count <= Number(this.dataset.columns));
      this.querySelector('.ear-compositions__controls').hidden = count < 2;
      if (count) this.querySelector('[data-composition-status]').hidden = true;
      slider.resetPages?.();
      window.solsticeCardMedia?.scan(this);
    }
  });
}
